import { Person } from "fhir/r5";
import { endpoints, oids } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { OAuthApplication } from "../../auth";
import { auxiliarData } from "../AuxiliarData";

/**
 * PUT de Person.
 * - Sem personId / existingResource: criação canônica {oids.cpf}-{cpf} (signup).
 * - Com existingResource: atualiza o recurso no próprio id (não reconstrói o body).
 */
export async function PutPerson(objData: any, applicationAuth?: any) {
  const existingResource = objData.existingResource as Person | undefined;
  const cpf = objData.identifier;
  const personId =
    objData.personId || existingResource?.id || `${oids.cpf}-${cpf}`;
  const url = `${endpoints.ADMFHIR}/Person/${personId}`;

  const data = existingResource
    ? JSON.stringify(existingResource)
    : auxiliarData.PersonAux({ ...objData, personId });
  const headers = {
    Accept: "*/*",
    Authorization: applicationAuth
      ? await OAuthApplication()
      : await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .put(url, data, { headers, timeout: 8000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PutPerson: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("PutPerson ", error);
      // toast.error(`PutPerson Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
